import { defineMessages } from 'react-intl';

export default defineMessages({
    underlyingPoliciesTitle: {
        id:'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.Underlying Policies',
        defaultMessage: 'Underlying Policies'
    },
    wmicUnderlyingPoliciesAtLeastOneHOPolicy: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.AtLeastOneHOPolicy',
        defaultMessage: '&lt;span&gt;At least &lt;b&gt;one Personal Property Policy&lt;/b&gt; is required&lt;/span&gt;'
    },
    wmicUnderlyingPoliciesPolicy: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.Policy',
        defaultMessage: 'Policy'
    },
    wmicUnderlyingPoliciesInsurer: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.Insurer',
        defaultMessage: 'Insurer'
    },
    wmicUnderlyingPoliciesRisks: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.Risks',
        defaultMessage: 'Risks'
    },
    wmicUnderlyingPoliciesPassengerVehicleRisk: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.PassengerVehicleRisk',
        defaultMessage: '1 Passenger Vehicle'
    },
    wmicUnderlyingPoliciesExcessPolicy: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.ExcessPolicy',
        defaultMessage: 'Excess Policy'
    },
    wmicUnderlyingPoliciesPassengerVehicleRisks: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.PassengerVehicleRisks',
        defaultMessage: '{number} Passenger Vehicles'
    },
    wmicUnderlyingPoliciesPersonalPropertyRisk: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.PersonalPropertyRisk',
        defaultMessage: '1 Personal Property'
    },
    wmicUnderlyingPoliciesPersonalPropertyRisks: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.PersonalPropertyRisks',
        defaultMessage: '{number} Personal Properties'
    },
    wmicUnderlyingPoliciesWatercraftRisk: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.WatercraftRisk',
        defaultMessage: '1 Watercraft'
    },
    wmicUnderlyingPoliciesWatercraftRisks: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.WatercraftRisks',
        defaultMessage: '{number} Watercraft'
    },
    wmicUnderlyingPoliciesAddUnderlyingPolicy: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.AddUnderlyingPolicy',
        defaultMessage: 'Add Underlying Policy'
    },
    wmicUnderlyingPoliciesInternalPolicy: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.internalPolicy',
        defaultMessage: ' {policyNumber} - {carrierName}'
    },
    wmicUnderlyingPoliciesRemoveUnderlyingPolicyConfirmationMsg: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.RemoveUnderlyingPolicyConfirmationMsg',
        defaultMessage: 'Are you sure you want to remove policy {policyNumber} from the list of underlying policies?'
    },
    wmicUnderlyingPoliciesRemoveUnderlyingPolicy: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.RemoveUnderlyingPolicy',
        defaultMessage: 'Remove Underlying Policy?'
    },
    wmicUnderlyingPoliciesRemovingLiabilityCoverage: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.RemovingLiabilityCoverage',
        defaultMessage: 'Removing Underlying Policy'
    },
    wmicUnderlyingPoliciesSavingLiabilityCoverage: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.SavingLiabilityCoverage',
        defaultMessage: 'Saving Underlying Policies'
    },
    wmicUnderlyingPoliciesInternalPolicyName: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.InternalPolicyName',
        defaultMessage: 'Wawanesa Mutual Insurance Company'
    },
    wmicUnderlyingPoliciesPersonalProperty: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.PersonalProperty',
        defaultMessage: 'Personal Property'
    },
    wmicUnderlyingPoliciesAuto: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.Automobile',
        defaultMessage: 'Automobile'
    },
    wmicUnderlyingPoliciesWatercraft: {
        id: 'wmic-pe-capability-gateway-policyRenewals-pup-react.WMICPUPPolicyRenewalsUnderlyingPoliciesPage.Watercraft',
        defaultMessage: 'Watercraft'
    }
});